import React from "react";
import styles from "./Table.module.css";

export const Table = () => {
    return (
        <div className={styles.container}>
            <div className={styles.header}>
                Данные по областям <span className={styles.headerStrong}></span>
            </div>
            <input
                type="text"
                placeholder="Поиск"
                className={styles.search}
            />
            <div className={styles.tableTitle}>
            Переработчики
            </div>
            <div className={styles.tableRow}>
            Переработчик Алай-Эт
            </div>
        </div>
    );
};   